import { FootInfoAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";

/** 页脚信息组件类 */
export class FootInfoComponent extends BaseComponent<
  FootInfoAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        FootInfoAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.foot_info;
  }

  // /** 获取页脚信息数据列表 */
  // public getFootInfoItems(): FootInfoItem[] {
  //   return this.attrs.data_list;
  // }

  // /** 设置页脚信息数据列表 */
  // public setFootInfoItems(items: FootInfoItem[]): void {
  //   this.setAttrs({ data_list: items });
  // }

  // /** 获取指定项的标题 */
  // public getItemTitleByLang(item: FootInfoItem, lang: string): string {
  //   return item.modal_title;
  // }

  // /** 获取指定项的内容 */
  // public getItemContentByLang(item: FootInfoItem, lang: string): string {
  //   return item.context_lang?.[lang] || "";
  // }
}

// // 使用示例
// const footInfoData: Partial<BaseComponent<FootInfoAttrs>> = {
//   id: "673f38499d40e0e312b096d1",
//   type: CompType.foot_info,
//   variant: "",
//   title: "",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "test_foot_info",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_text: {
//       "12": "foot_info",
//       "1": "foot_info",
//       "4": "foot_info",
//       "11": "foot_info",
//     },
//     data_list: [
//       {
//         status: 1,
//         modal_title: "网站信息",
//         context_lang: {
//           "11": "<p>As informa&ccedil;&otilde;es sobre handicaps e probabilidades esportivas contidas neste site s&atilde;o apenas para fins de entretenimento...</p>",
//           "12": "<p>La informaci&oacute;n sobre handicaps y probabilidades deportivas contenida en este sitio es solo para fines de entretenimiento...</p>",
//           "1": "<p>The information about handicaps and sports odds contained on this site is for entertainment purposes only...</p>",
//           "4": "<p>本網站所包含的讓分和體育賠率的資訊僅供娛樂之用...</p>",
//         },
//         img_list: [
//           {
//             img_url:
//               "https://web-res-ccc.afunimg8.com/cdn-cgi/image/format=auto/C02/602/logo/logo-h.png?20241112",
//             click_id: 0,
//             click_params: "",
//             is_system_license: 1,
//           },
//         ],
//         key: 1732196578515,
//       },
//     ],
//   },
// };
